<template>
    <div class="p-2">
        <div class="form-group">
            <label for="zoom" class="form-control-label mb-0">{{ trans('Mode') }}:</label>
            <v-select
                :placeholder="trans('Select...')"
                id="zoom_id"
                label="text"
                :options="zoomOptions"
                :modelValue="filters.zoom"
                @update:modelValue="filters.zoom = $event"
                :reduce="(zoom) => zoom.id"
            >
            </v-select>
        </div>
        <div class="form-group">
            <label for="amount_id" class="form-control-label mb-0">{{ trans('Amount') }}:</label>
            <v-select
                :placeholder="trans('Select...')"
                id="amount_id"
                label="text"
                :options="zoomAmountOptions"
                :modelValue="filters.amount"
                @update:modelValue="filters.amount = $event"
            >
            </v-select>
        </div>
        <div class="form-group">
            <label for="from_date" class="form-control-label mb-0">{{ trans('Date') }}:</label>
            <vue-flatpickr
                :modelValue="filters.date"
                @update:modelValue="filters.date = $event"
                :config="{
                    allowInput: true,
                    dateFormat: 'Y-m-d',
                    altInput: true,
                    altFormat: 'd/m/Y',
                }"
                :placeholder="trans('Select date')"
                class="form-control"
                name="from_date"
                autocomplete="off"
            >
            </vue-flatpickr>
        </div>
        <div v-if="planningType !== 'capacity'" class="form-group">
            <label for="status_id" class="form-control-label mb-0">{{ trans('Status') }}:</label>
            <v-select
                :placeholder="trans('Select...')"
                id="status_id"
                label="title"
                :options="taskStatuses"
                :reduce="(status) => status.id"
                :modelValue="filters.statuses"
                @update:modelValue="filters.statuses = $event"
                multiple
            >
                <template v-slot:option="option">
                    <div class="d-center">
                        <span
                            class="badge"
                            :style="'background-color:' + option.color + '; color: #fff;'"
                        >
                            {{ option.title }}
                        </span>
                    </div>
                </template>
                <template v-slot:selected-option="option">
                    <div class="selected d-center">
                        <span
                            class="badge"
                            :style="'background-color:' + option.color + '; color: #fff;'"
                        >
                            {{ option.title }}
                        </span>
                    </div>
                </template>
            </v-select>
        </div>
        <div v-if="isDayListPlanning" class="form-group">
            <label for="clients_id" class="form-control-label mb-0">{{ trans('Client') }}:</label>
            <v-select
                :placeholder="trans('Select...')"
                id="clients_id"
                label="text"
                :options="clientOptions"
                :modelValue="filters.clients"
                @update:modelValue="filters.clients = $event"
                :reduce="(option) => option.id"
                multiple
            >
                <template v-slot:option="option">
                    <i :class="option.icon"></i> {{ option.text }}
                </template>
                <template v-slot:selected-option="option">
                    <i :class="option.icon"></i> {{ option.text }}
                </template>
            </v-select>
        </div>
        <div v-if="isDayListPlanning" class="form-group">
            <label for="projects_id" class="form-control-label mb-0">{{ trans('Project') }}:</label>
            <v-select
                :placeholder="trans('Select...')"
                id="projects_id"
                label="text"
                :options="projectOptions"
                :modelValue="filters.projects"
                @update:modelValue="filters.projects = $event"
                :reduce="(option) => option.id"
                multiple
            >
            </v-select>
        </div>
        <div v-if="isDayListPlanning" class="form-group">
            <label for="resources_id" class="form-control-label mb-0">{{ trans('Resources') }}:</label>
            <v-select
                :placeholder="trans('Select...')"
                id="resources_id"
                label="text"
                :options="resourceOptions"
                :modelValue="filters.resources"
                @update:modelValue="filters.resources = $event"
                :reduce="(option) => option.id"
                multiple
            >
                <template v-slot:option="option">
                    <i :class="option.icon"></i> {{ option.text }}
                </template>
                <template v-slot:selected-option="option">
                    <i :class="option.icon"></i> {{ option.text }}
                </template>
            </v-select>
        </div>
        <div class="form-group" v-if="mode === 'project'">
            <label for="planned" class="form-control-label mb-0">{{ trans('Planned') }}/{{ trans('Not planned') }}: </label>
            <v-select
                :placeholder="trans('Select...')"
                id="planned_project_id"
                label="text"
                :options="plannedOptions"
                :modelValue="filters.planned"
                @update:modelValue="filters.planned = $event"
                :reduce="(option) => option.id"
            > 
            </v-select>
        </div>
        <!--        <div class="form-group" v-if="mode === 'person'">-->
        <!--            <label for="planned" class="form-control-label mb-0">{{ trans('Planned') }}: </label>-->
        <!--            <v-select :placeholder="trans('Select...')" id="planned_person_id" label="text">-->
        <!--            </v-select>-->
        <!--        </div>-->
        <button class="btn btn-secondary" type="button" @click.stop="reset()">
            {{ trans('reset') }}
        </button>
        <button class="btn btn-primary ml-1" type="button" @click.stop="save()">
            {{ trans('filter') }}
        </button>
    </div>
</template>

<script>
import VueFlatpickr from 'vue-flatpickr-component';
import { mapActions, mapMutations, mapState } from 'vuex';
import { MODE, ZOOM_LEVEL, ZOOM_SETTINGS } from '../../../constants';
import { DateTimeFormatter, LocalDate } from '@js-joda/core';

const dateformatter = DateTimeFormatter.ofPattern('yyyy-MM-dd');

export default {
    components: {
        VueFlatpickr,
    },
    data() {
        return {
            dateFormat: 'dd-mm-yyyy',
            filters: {
                zoom: null,
                amount: null,
                date: null,
                statuses: [],
                planned: 'all',
                clients: [],
                projects: [],
                resources: [],
            },
            taskStatuses: [],
            clientOptions: [],
            projectOptions: [],
            resourceOptions: [],
        };
    },
    methods: {
        ...mapMutations('planning', [
            'setCurrentAmountToShow',
            'setCurrentZoom',
            'setStatusesToShow',
            'setPlannedToShow',
            'setClientsToShow',
            'setProjectsToShow',
            'setResourcesToShow',
        ]),
        ...mapActions('planning', ['resetCalendar']),
        save() {
            this.setCurrentZoom(this.filters.zoom);
            this.setCurrentAmountToShow(this.filters.amount);
            this.setStatusesToShow(this.filters.statuses);
            this.setPlannedToShow(this.filters.planned);

            if (this.isDayListPlanning) {
                this.setClientsToShow(this.filters.clients);
                this.setProjectsToShow(this.filters.projects);
                this.setResourcesToShow(this.filters.resources);
            }

            var queryParams = new URLSearchParams(window.location.search);
            queryParams.set('date', this.filters.date);
            history.pushState(null, null, '?' + queryParams.toString());

            this.resetCalendar();
        },
        reset() {
            let date = LocalDate.now();
            this.filters = {
                zoom: this.currentZoom,
                amount: ZOOM_SETTINGS[this.currentZoom].amountToShow,
                date: date.format(dateformatter),
                statuses: [],
                planned: 'all',
                clients: [],
                projects: [],
                resources: [],
            };
            this.save();
        },
        getTaskStatuses() {
            let url = route('task.get-task-statuses');

            axios.get(url).then((response) => {
                this.taskStatuses = response.data.taskStatuses;
            });
        },
        getClients() {
            axios.get(route('clients.list')).then((response) => {
                const companies = response.data.companies.map((c) => ({
                    id: 'company_' + c.id,
                    text: c.company_name,
                    icon: 'icofont-building-alt',
                }));
                const contacts = response.data.contacts.map((c) => ({
                    id: 'contact_' + c.id,
                    text: ((c.last_name || '') + ' ' + (c.first_name || '')).trim(),
                    icon: 'icofont-user-alt-3',
                }));
                this.clientOptions = [...companies, ...contacts].sort((a, b) =>
                    a.text.localeCompare(b.text)
                );
            });
        },
        getProjects() {
            axios.get(route('projects.list')).then((response) => {
                this.projectOptions = response.data.projects.map((p) => ({
                    id: p.id,
                    text: p.internal_id ? p.internal_id + ' - ' + p.title : p.title,
                }));
            });
        },
        getResources() {
            axios.get(route('resources.list')).then((response) => {
                const persons = response.data.persons.map((p) => ({
                    id: 'person_' + p.id,
                    text: ((p.last_name || '') + ' ' + (p.first_name || '')).trim(),
                    icon: 'icofont-user',
                }));
                const equipments = response.data.equipments.map((e) => ({
                    id: 'equipment_' + e.id,
                    text: e.title,
                    icon: 'icofont-vehicle-cement',
                }));
                this.resourceOptions = [...persons, ...equipments];
            });
        },
    },
    computed: {
        ...mapState('planning', [
            'mode',
            'currentZoom',
            'currentAmountToShow',
            'dateToShow',
            'statusesToShow',
            'plannedToShow',
            'clientsToShow',
            'projectsToShow',
            'resourcesToShow',
        ]),
        planningType() {
            return MODE[this.mode].type;
        },
        isDayListPlanning() {
            return this.mode === 'dayListPlanning';
        },

        plannedOptions() {
            return [
                { id: 'all', text: trans('All') },
                { id: 'planned', text: trans('Only planned') },
                { id: 'not_planned', text: trans('Only not planned') },
            ];
        },

        zoomOptions() {
            let zoomOpions = [
                {
                    id: ZOOM_LEVEL.week,
                    text: trans('Week'),
                },
                {
                    id: ZOOM_LEVEL.month,
                    text: trans('Month'),
                },
            ];

            if (this.planningType !== 'capacity') {
                zoomOpions.unshift({
                    id: ZOOM_LEVEL.day,
                    text: trans('Day'),
                });
            }
            return zoomOpions;
        },
        zoomAmountOptions() {
            let items = [];

            switch (this.filters.zoom) {
                case ZOOM_LEVEL.day:
                    items = items = Array.from({ length: 14 }, (_, index) => index + 1);
                    break;
                case ZOOM_LEVEL.week:
                    items = items = Array.from({ length: 12 }, (_, index) => index + 1);
                    break;
                case ZOOM_LEVEL.month:
                    items = items = Array.from({ length: 12 }, (_, index) => index + 1);
                    break;
            }

            return items;
        },
    },
    created() {
        this.getTaskStatuses();

        if (this.isDayListPlanning) {
            this.getClients();
            this.getProjects();
            this.getResources();
        }

        this.filters = {
            zoom: this.currentZoom,
            amount: this.currentAmountToShow,
            date: this.dateToShow.format(dateformatter),
            statuses: this.statusesToShow,
            planned: this.plannedToShow || this.$store.state.planning?.plannedDefault || 'all',
            clients: this.clientsToShow,
            projects: this.projectsToShow,
            resources: this.resourcesToShow,
        };
    },
};
</script>

<style scoped></style>
